module.exports = __webpack_public_path__ + "static/media/plp-dont-know-desktop.d1e3f77b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plp-dont-know-desktop.jpg
// module id = 451
// module chunks = 0